import {createAsyncThunk} from "@reduxjs/toolkit";
import {
    acceptInvite,
    addOrganizationBusinessWithBilling,
    addOrganizationBusinessWithoutPayment,
    addOrganizationEnterprise,
    addOrganizationFree,
    cancelWorkspaceInvite,
    changeCurrentUserInfo,
    changeCurrentUserPass,
    createRole,
    createWorkspace,
    declineInvite,
    deleteNotCompletedOrganization,
    deleteRole,
    deleteWorkspace,
    deleteWorkspaceCollaborator,
    disableGoogleAuthApi,
    getCreateOrganizationData,
    getInvites,
    getOrganizationBilling,
    getOrganizationById,
    getOrganizations,
    getSmallOrgsAndWorkspacesForSelect,
    getWorkspaceById,
    getWorkspaceCollabs,
    getWorkspaces,
    importCsvTemplateCollaboratorsApi,
    inviteMemberIntoWorkspace,
    reconfigureGoogleAuthApi,
    resendWorkspaceInvite,
    sendSupportMessageAPI,
    transferOrganizationOwnership,
    updateCollabRole,
    updateOrganizationBillingInfo,
    updateOrganizationLogo,
    updateOrganizationName,
    updateRole,
    updateUserRole,
    updateWorkspaceName,
    validate2faCodeApi
} from "../api";
import {
    cookieShortOrganization,
    cookieShortWorkspace,
    createOrganizationType,
    ForbiddenWrapperOrganization,
    getWorkspaceCollabsResponseType,
    TBillingInfo,
    TChangeUserInfo,
    TChangeUserPass,
    TWorkspaceInvite,
    TWorkspaceRole,
    TWorkspaceWithShortCollabs
} from "../types";
import {CreateOrganizationDto, Validate2faCodeMutationVariables} from "../../../../newShared/GQLTypes";
import {cleanOrganizations, cleanWorkspaces} from "./slice";
import {AppState} from "../../../../newShared/redux/rootReducer";
import {getActionsData} from "../../../../newShared/redux";
import {saveAs} from "file-saver";
import {b64toBlob} from "../../../../newShared/utils/base64/base64";


export const GetInvites = createAsyncThunk(
    'Settings/GetInvites',
    async (): Promise<TWorkspaceInvite[]> => {
        return await getInvites();
    }
);

export const AcceptInvite = createAsyncThunk(
    'Settings/acceptInvite',
    async (data: {inviteId: string, onSuccess?: () => void}, {dispatch}): Promise<string> => {
        await acceptInvite(data.inviteId);
        data.onSuccess && data.onSuccess();
        return data.inviteId;
    }
);

export const DeclineInvite = createAsyncThunk(
    'Settings/declineInvite',
    async (data: {inviteId: string}, {dispatch}): Promise<string> => {
        await declineInvite(data.inviteId);
        return data.inviteId;
    }
);

//USER PROFILE
export const ChangeCurrentUserInfo = createAsyncThunk(
    'Settings/changeCurrentUserInfo',
    async ({data, onSuccess}: { data: TChangeUserInfo, onSuccess: () => void }, {dispatch, getState}) => {
        const resp = await changeCurrentUserInfo(data);
        data && onSuccess();
        return resp
    },
);

//SECURITY
export const ChangeCurrentUserPassword = createAsyncThunk(
    'Settings/ChangeCurrentUserPassword',
    async ({data, onSuccess}: { data: TChangeUserPass, onSuccess: () => void }, {dispatch, getState}) => {
        const resp = await changeCurrentUserPass(data);
        resp  && onSuccess();
        return resp
    },
);

export const validate2faCodeAction = createAsyncThunk(
    'Settings/validate2faCode',
    async (data: Validate2faCodeMutationVariables & {onSuccess: () => void}, {dispatch, getState}) => {
        // const state = getState() as AppState;
        // const workspaceId = state.workspace.workspaceId || '';
        const resp = await validate2faCodeApi({code: data.code, secret: data.secret});
        data.onSuccess();
        return resp
    },
);

export const reconfigureGoogleAuthAction = createAsyncThunk(
    'Settings/reconfigureGoogleAuth',
    async (data: {onSuccess: () => void}, {dispatch, getState}) => {
        // const state = getState() as AppState;
        // const workspaceId = state.workspace.workspaceId || '';
        const resp = await reconfigureGoogleAuthApi({});
        data.onSuccess();
        return resp
    },
);

export const disableGoogleAuthAction = createAsyncThunk(
    'Settings/disableGoogleAuth',
    async (data: {onSuccess: () => void}, {dispatch, getState}) => {
        // const state = getState() as AppState;
        // const workspaceId = state.workspace.workspaceId || '';
        const resp = await disableGoogleAuthApi({});
        data.onSuccess();
        return resp
    },
);



//WORKSPACES & ORGS


export const GetOrganizations = createAsyncThunk(
    'Settings/getOrganizations',
    async ({page, count, name, removeBeforeFetch}: {page: number, count: number, name: string, removeBeforeFetch: boolean}, {dispatch}) => {
        removeBeforeFetch && dispatch(cleanOrganizations());
        return  await getOrganizations(page, count, name);
    },
);

//getOrganizationById

export const GetOrganizationById = createAsyncThunk(
    'Settings/getOrganizationById',
    async ({id, onReject}: {id: string, onReject: () => void}, {dispatch}) => {
        try{
            return await getOrganizationById(id);
        }catch (ex: any){
            onReject();
            throw new Error(ex.message);
        }
    },
);

//getWorkspaces

export const GetWorkspaces = createAsyncThunk(
    'Settings/getWorkspaces',
    async ({page, count, name, id, removeBeforeFetch}: {id: string, page: number, count: number, name: string, removeBeforeFetch: boolean}, {dispatch}) => {
        removeBeforeFetch && dispatch(cleanWorkspaces());
        return  await getWorkspaces(page, count, name, id);
    },
);

//Change KYC limit status
//
// export const kycSetLimitAction = createAsyncThunk(
//     'Settings/Workspace/kycSetLimit',
//     async (data: TWithOptions<KycSetLimitMutationVariables>, {dispatch, getState}) => {
//         const state = getState() as AppState;
//         const {organizationId, workspaceId} = getActionsData(state);
//
//         const resp = await kycSetLimitApi({...data.data, organizationId, workspaceId}, data.signal);
//
//         return {
//             data: data.data,
//             resp
//         }
//     },
// );

//updateOrganizationByLicenseCode
// export const UpdateOrganizationByLicenseCode = createAsyncThunk(
//     'Settings/updateOrganizationByLicenseCode',
//     async ({organizationId, licenseCode, onSuccess}: {organizationId: string, licenseCode: string, onSuccess?: (newSubscription: string) => void}, {dispatch}) => {
//
//         const res =  await updateOrganizationByLicenseCode(organizationId, licenseCode);
//         if(res){
//             onSuccess && onSuccess(res.subscription);
//         }
//
//         return res;
//     },
// );

//sendSupportMessageAPI

export const SendSupportMessageAPI = createAsyncThunk(
    'Settings/sendSupportMessageAPI',
    async ({organizationId, currSub, subscription, onSuccess}: {organizationId: string, currSub: string, subscription: string, onSuccess: () => void}, {dispatch, getState}) => {
        const state = getState() as AppState;
        const {publicId} = getActionsData(state);

        const res =  await sendSupportMessageAPI({
            wid: '',
            data: {
                message: `User (${publicId}) requested subscription update: ${currSub} TO ${subscription} IN ORG: ${organizationId}`,
                subject: 'Subscription updated requested!',
                type: 'subscription update'
            }
        });

        res && onSuccess();
        return res;
    },
);

//createOrganization
// export const CreateOrganization = createAsyncThunk(
//     'Settings/createOrganization',
//     async ({data, billingInfo, onSuccess}: {data: createOrganizationType, billingInfo?: TBillingInfo, onSuccess: (workspace: cookieShortWorkspace, organization: cookieShortOrganization, transactionNumber: string | null) => void}, {dispatch, getState}) => {
//         const res = await createOrganization(data, billingInfo);
//         onSuccess(res.workspace, res.organization, res.transactionNumber);
//         return res;
//     },
// );

// export const GetOrganizationCollaborators = createAsyncThunk(
//     'Settings/getOrganizationCollaborators',
//     async ({id, onSuccess, onReject}: {id: string, onSuccess?: () => void, onReject?: () => void}, {dispatch, getState}) => {
//         const res = await getOrganizationCollaborators(id);
//         res && onSuccess && onSuccess();
//         !res && onReject && onReject();
//         return res;
//     },
// );

//cancelOrganizationInvite
// export const CancelOrganizationInvite = createAsyncThunk(
//     'Settings/cancelOrganizationInvite',
//     async (data: {organizationId: string, email: string, inviteId: string, onSuccess?: () => void}, {dispatch} ): Promise<{organizationId: string, email: string, inviteId: string}> => {
//         const mes = await cancelOrganizationInvite(data.organizationId, data.email, data.inviteId);
//         mes && data.onSuccess && data.onSuccess();
//         return data;
//     }
// );

//resendOrganizationInvite

// export const ResendOrganizationInvite = createAsyncThunk(
//     'Settings/resendOrganizationInvite',
//     async (data: {organizationId: string, email: string, inviteId: string, onSuccess?: () => void}, {dispatch} ): Promise<{organizationId: string, email: string, inviteId: string}> => {
//         const mes = await resendOrganizationInvite(data.organizationId, data.email, data.inviteId);
//         mes && data.onSuccess && data.onSuccess();
//         return data;
//     }
// );

//updateInviteRole
//
// export const UpdateInviteRole = createAsyncThunk(
//     'Settings/updateInviteRole',
//     async (data: {organizationId: string, email: string, newRole: string, inviteId: string, onSuccess?: () => void, onReject?: () => void}, {dispatch} ): Promise<{organizationId: string, email: string, newRole: string} | undefined> => {
//         try{
//             await updateInviteRole(data.organizationId, data.email, data.newRole, data.inviteId);
//             data.onSuccess && data.onSuccess();
//             return data;
//         }catch (ex){
//             dispatch(prevInviteRoleRollback());
//             data.onReject && data.onReject();
//         }
//     }
// );

export const UpdateCollabRole = createAsyncThunk(
    'Settings/updateCollabRole',
    async (data: {organizationId: string, publicId: string, newRole: string}, {dispatch} ): Promise<{organizationId: string, publicId: string, newRole: string} | undefined> => {
        await updateCollabRole(data.organizationId, data.publicId, data.newRole);
        return data;
    }
);

//createWorkspace
export const CreateWorkspace = createAsyncThunk(
    'Settings/CreateWorkspace',
    async (data: {organizationId: string, workspaceName: string, onSuccess: (name: string, id: string) => void}, {dispatch}): Promise<TWorkspaceWithShortCollabs> => {
        const res = await createWorkspace(data.organizationId, data.workspaceName);
        if(res) data.onSuccess(res.name, res.id);
        return res;
    }
);

export const UpdateOrganizationName = createAsyncThunk(
    'Settings/updateOrganizationName',
    async (data: {organizationId: string, newName: string} ): Promise<{organizationId: string, newName: string}> => {
        await updateOrganizationName(data.organizationId, data.newName);
        return data;
    }
);

//updateOrganizationLogo
export const UpdateOrganizationLogo = createAsyncThunk(
    'Settings/updateOrganizationLogo',
    async (data: {organizationId: string, newLogo: string} ): Promise<{organizationId: string, newLogo: string}> => {
        await updateOrganizationLogo(data.organizationId, data.newLogo);
        return data;
    }
);

// export const InviteMemberIntoOrg = createAsyncThunk(
//     'Settings/inviteMemberIntoOrg',
//     async (data: {organizationId: string, email: string, role: string, onSuccess: () => void}, {getState, dispatch} ): Promise<TOrganizationInvite> => {
//         const state = getState() as AppState;
//         const publicId = state.SharedWorkspacesAndOrganizations.store.currentUser?.publicId || '';
//         const res = await inviteMemberIntoOrg(data.organizationId, data.email, data.role, publicId);
//         if(res) data.onSuccess();
//         return res;
//     }
// );

//transferOrganizationOwnership
export const TransferOrganizationOwnership = createAsyncThunk(
    'Settings/transferOrganizationOwnership',
    async (data: {organizationId: string, transferToPublicId: string, transferFromPublicId: string, onSuccess: () => void}, {dispatch} ): Promise<{organizationId: string, transferToPublicId: string, transferFromPublicId: string, onSuccess: () => void}> => {
        const mes = await transferOrganizationOwnership(data.organizationId, data.transferToPublicId, data.transferFromPublicId);
        if(mes) data.onSuccess();
        return data;
    }
);

//deleteOrganizationCollaborator
// export const DeleteOrganizationCollaborator = createAsyncThunk(
//     'Settings/deleteOrganizationCollaborator',
//     async (data: {organizationId: string, publicId: string, onSuccess: () => void}, {getState, dispatch} ): Promise<{organizationId: string, publicId: string}> => {
//         const mes = await deleteOrganizationCollaborator(data.organizationId, data.publicId);
//         if(mes) data.onSuccess();
//         return data;
//     }
// );

//getWorkspaceById
export const GetWorkspaceById = createAsyncThunk(
    'Settings/getWorkspaceById',
    async (data: {organizationId: string, workspaceId: string, onSuccess?: () => void, onReject?: (snack: string) => void}, {getState, dispatch} ) => {
        try{
            const res = await getWorkspaceById(data.organizationId, data.workspaceId);
            data.onSuccess && data.onSuccess();
            return res;
        }catch (e: any){
            data.onReject && data.onReject(e.message);
        }
    }
);

// getWorkspaceCollabs
export const GetWorkspaceCollabs = createAsyncThunk(
    'Settings/getWorkspaceCollabs',
    async (data: {workspaceId: string, onSuccess?: () => void, onReject?: (snack: string) => void}, {getState, dispatch} ) => {
        try{
            const res = await getWorkspaceCollabs(data.workspaceId);
            data.onSuccess && data.onSuccess();
            return res;
        }catch (e: any){
            data.onReject && data.onReject(e.message);
        }
    }
);

export const DeleteWorkspaceCollaborator = createAsyncThunk(
    'Settings/deleteWorkspaceCollaborator',
    async (data: { workspaceId: string, publicId: string, onSuccess: () => void}, {dispatch} ): Promise<string> => {
        const mes = await deleteWorkspaceCollaborator(data.workspaceId, data.publicId);
        if(mes){
            data.onSuccess();
        }
        return data.publicId;
    }
);

export const UpdateWorkspaceName = createAsyncThunk(
    'Settings/updateWorkspaceName',
    async (data: {workspaceId: string, newName: string, onSuccess: () => void} ): Promise<{workspaceId: string, newName: string}> => {
        await updateWorkspaceName(data.workspaceId, data.newName);
        data.onSuccess();
        return data;
    }
);

//deleteWorkspace
export const DeleteWorkspace = createAsyncThunk(
    'Settings/deleteWorkspace',
    async (data: { workspaceId: string, onSuccess: () => void}, {dispatch} ): Promise<string> => {
        const mes = await deleteWorkspace(data.workspaceId);
        if(mes){
            data.onSuccess();
        }
        return data.workspaceId;
    }
);


//inviteMemberIntoWorkspace
export const InviteMemberIntoWorkspace = createAsyncThunk(
    'Settings/inviteMemberIntoWorkspace',
    async (data: {workspaceId: string, email: string, roles: TWorkspaceRole[], organizationId: string, onSuccess: () => void}, {getState, dispatch} ): Promise<getWorkspaceCollabsResponseType> => {
        const state = getState() as AppState;
        const publicId = state.SharedWorkspacesAndOrganizations.store.currentUser?.publicId || '';
        return inviteMemberIntoWorkspace(data.workspaceId, data.email, data.roles.map(e => e.name), publicId);
    }
);

//updateUserRole
export const UpdateUserRole = createAsyncThunk(
    'Settings/updateUserRole',
    async (data: { workspaceId: string, publicId: string, roles: TWorkspaceRole[], onSuccess?: () => void}, {dispatch} ) => {
        const mes = await updateUserRole(data.workspaceId, data.publicId, data.roles.map(e => e.name));
        if(mes){
            data.onSuccess && data.onSuccess();
        }
        return {
            publicId: data.publicId,
            roles: data.roles
        }
    }
);

export const ResendWorkspaceInvite = createAsyncThunk(
    'Settings/resendWorkspaceInvite',
    async (data: {workspaceId: string, email: string, inviteId: string, onSuccess: () => void}, {dispatch} ): Promise<{workspaceId: string, email: string, inviteId: string}> => {
        const mes = await resendWorkspaceInvite(data.workspaceId, data.email, data.inviteId);
        // dispatch(addInfoSnack(mes));
        if(mes) data.onSuccess();
        return data;
    }
);

//cancelWorkspaceInvite
export const CancelWorkspaceInvite = createAsyncThunk(
    'Settings/cancelWorkspaceInvite',
    async (data: {workspaceId: string, email: string, inviteId: string, onSuccess: () => void}, {dispatch} ): Promise<{workspaceId: string, email: string, inviteId: string}> => {
        const mes = await cancelWorkspaceInvite(data.workspaceId, data.email, data.inviteId);
        // dispatch(addInfoSnack(mes));
        if(mes) data.onSuccess();
        return data;
    }
);

// export const ChangeWSInviteRole = createAsyncThunk(
//     'Settings/changeWSInviteRole',
//     async (data: {workspaceId: string, email: string, newRole: string, inviteId: string}, {dispatch} ): Promise<{workspaceId: string, email: string, newRole: string} | undefined> => {
//         try{
//             await changeWSInviteRole(data.workspaceId, data.email, data.newRole, data.inviteId);
//             return data;
//         }catch (ex){
//             dispatch(prevWSInviteRoleRollback());
//         }
//     }
// );

//createRole
export const CreateRole = createAsyncThunk(
    'Settings/createRole',
    async (data: {role: TWorkspaceRole, workspaceId: string, onSuccess: () => void}, {dispatch} ): Promise<TWorkspaceRole | undefined> => {
        try{
            const id = await createRole({name: data.role.name, permissions: data.role.permissions, workspaceId: data.workspaceId, id: null});
            id && data.onSuccess();
            return {
                ...data.role,
                createDate: new Date(Date.now()).toISOString(),
                lastUpdateDate: new Date(Date.now()).toISOString(),
                id
            };
        }catch (ex){
            //todo
        }
    }
);
//deleteRole

export const DeleteRole = createAsyncThunk(
    'Settings/deleteRole',
    async (data: {role: TWorkspaceRole, workspaceId: string}, {dispatch} ): Promise<TWorkspaceRole | undefined> => {
        try{
            await deleteRole(data.workspaceId, data.role.id);
            return data.role;
        }catch (ex){
            //todo
        }
    }
);

//updateRole
export const UpdateRole = createAsyncThunk(
    'Settings/updateRole',
    async (data: {role: TWorkspaceRole, workspaceId: string, onSuccess: () => void}, {dispatch} ): Promise<TWorkspaceRole | undefined> => {
        try{
            const id = await updateRole({name: data.role.name, permissions: data.role.permissions, workspaceId: data.workspaceId, id: data.role.id});
            id && data.onSuccess();
            return {
                ...data.role,
                lastUpdateDate: new Date(Date.now()).toISOString(),
                id
            };
        }catch (ex){
            //todo
        }
    }
);

export const GetSmallOrgsAndWorkspacesForSelect = createAsyncThunk(
    'Settings/getSmallOrgsAndWorkspacesForSelect',
    async (data: {}, {dispatch} ): Promise<ForbiddenWrapperOrganization[]> => {
        return await getSmallOrgsAndWorkspacesForSelect();
    }
);

// export const JoinWorkspaceByOrgAdmin = createAsyncThunk(
//     'Settings/joinWorkspaceByOrgAdmin',
//     async (data: {workspaceId: string, user: TUserInfo, onSuccess: () => void, adminWsRole: TWorkspaceRole}, {dispatch, getState} ): Promise<TWorkspaceCollaborator> => {
//         await joinWorkspaceByOrgAdmin(data.workspaceId);
//         data.onSuccess();
//         dispatch(GetSmallOrgsAndWorkspacesForSelect({}));
//         return {
//             ...data.user,
//             roles: [data.adminWsRole],
//             createDate: data.user.creationDate,
//         }
//     }
// );

//getCreateOrganizationData
export const GetCreateOrganizationData = createAsyncThunk(
    'Settings/getCreateOrganizationData',
    async () => {
        return await getCreateOrganizationData();
    }
);

export const AddOrganizationFree = createAsyncThunk(
    'Settings/addOrganizationFree',
    async ({data, onSuccess}: {data: createOrganizationType, onSuccess: (workspace: cookieShortWorkspace, organization: cookieShortOrganization) => void}, {dispatch, getState}) => {
        const res = await addOrganizationFree(data);
        onSuccess(res.workspace, res.organization);
        return res;
    },
);

//addOrganizationEnterprise
export const AddOrganizationEnterprise = createAsyncThunk(
    'Settings/addOrganizationEnterprise',
    async ({data, onSuccess}: {data: createOrganizationType, onSuccess: (workspace: cookieShortWorkspace, organization: cookieShortOrganization) => void}, {dispatch, getState}) => {
        const res = await addOrganizationEnterprise(data);
        onSuccess(res.workspace, res.organization);
        return res;
    },
);

//addOrganizationEnterprise
export const AddOrganizationBusinessWithoutPayment = createAsyncThunk(
    'Settings/addOrganizationBusinessWithoutPayment',
    async ({data, onSuccess}: {data: createOrganizationType, onSuccess: (workspace: cookieShortWorkspace, organization: cookieShortOrganization) => void}, {dispatch, getState}) => {
        const res = await addOrganizationBusinessWithoutPayment(data);
        onSuccess(res.workspace, res.organization);
        return res;
    },
);

//addOrganizationBusinessWithBilling
export const AddOrganizationBusinessWithBilling = createAsyncThunk(
    'Settings/addOrganizationBusinessWithBilling',
    async ({data, onSuccess, billing, calculatedTotal}: {data: CreateOrganizationDto, billing: TBillingInfo, calculatedTotal: number, onSuccess: () => void}, {dispatch, getState}) => {
        const res = await addOrganizationBusinessWithBilling(data, calculatedTotal, billing);
        onSuccess();
        return res;
    },
);

//deleteNotCompletedOrganization
export const DeleteNotCompletedOrganization = createAsyncThunk(
    'Settings/deleteNotCompletedOrganization',
    async ({onSuccess}: {onSuccess: () => void}, {dispatch, getState}) => {
        const mes = await deleteNotCompletedOrganization();
        onSuccess();
        return mes;
    },
);

//getOrganizationBilling
export const GetOrganizationBilling = createAsyncThunk(
    'Settings/getOrganizationBilling',
    async ({organizationId}: {organizationId: string}, {dispatch, getState}) => {
        const mes = await getOrganizationBilling(organizationId);
        return mes;
    },
);

//getOrganizationBilling
export const UpdateOrganizationBillingInfo = createAsyncThunk(
    'Settings/updateOrganizationBillingInfo',
    async ({organizationId, onSuccess, billing}: {organizationId: string, billing: TBillingInfo, onSuccess: () => void}, {dispatch, getState}) => {
        const mes = await updateOrganizationBillingInfo(organizationId, billing);
        onSuccess();
        return mes;
    },
);

export const importCsvTemplateCollaboratorsAction = createAsyncThunk(
    'Settings/importCsvTemplateCollaboratorsAction',
    async (_, {getState, dispatch}) => {
        const state = getState() as AppState;
        const {workspaceId} = getActionsData(state);

        const resp = await importCsvTemplateCollaboratorsApi({workspaceId});
        resp && saveAs(b64toBlob(resp as string), 'collaborators-template.csv');
        return resp
    }
)


// export const getCsvFieldsCollaboratorsAction =
//     createCommonAsyncThunk<GetCsvFieldsCollaboratorsMutationVariables, GetCsvFieldsCollaboratorsMutation["getCsvFieldsCollaborators"]>(
//         'Settings', 'getCsvFieldsCollaborators', true, false, getCsvFieldsCollaborators
//     )
// export const performCsvCollaboratorsAction =
//     createCommonAsyncThunk<PerformCsvCollaboratorsMutationVariables, PerformCsvCollaboratorsMutation["performCsvCollaborators"]>(
//         'Settings', 'performCsvCollaborators', true, false, performCsvCollaborators,
//     )
